<template>
  <div id="ylContactHire">
    <ylContactHireMobile v-if="isMobileScreen" :list="list" />
    <ylContactHirePC v-else :list="list" />
  </div>
</template>
<script>
export default {
  name: "ylContactHire",
  components: {
    ylContactHireMobile: () => import("./components/mobile.vue"),
    ylContactHirePC: () => import("./components/pc.vue"),
  },
  data() {
    return {
      list: [],
    }
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() {
    this.hr()
  },
  methods: {
    async hr() {
      const res = await this.$api.hr()
      this.list = res
    }
  }
};
</script>